import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Stack,
  Typography,
} from '@mui/material';
import { orderBy } from 'lodash';
import { useState } from 'react';

export const MultipleOrgUsersModal = ({
  open,
  user,
  organizations: organizationsProp,
  confirmLabel = 'Delete',
  onClose = () => {},
  onDeleteUsers = () => {},
}) => {
  const [selectedOrganizations, setSelectedOrganizations] = useState([]);

  const organizations = organizationsProp
    ? orderBy(organizationsProp, 'name')
    : orderBy(
        user?.users_user_organizations?.map((uo) => ({
          id: uo?.user_organizations_organization?.organization_id,
          name: uo?.user_organizations_organization?.name,
        })),
        'name'
      );

  const handleDeleteUser = () => {
    onDeleteUsers(user?.user_id, selectedOrganizations);
    onClose();
  };

  return (
    <Dialog open={open} fullWidth>
      <DialogTitle>Multiple Organizations</DialogTitle>
      <DialogContent>
        <Typography sx={{ mb: 2 }}>
          Choose the organizations you wish to remove this user for:
        </Typography>
        <Stack gap={1}>
          <FormControlLabel
            label={
              <Typography variant={'body2'} fontWeight={'bold'}>
                Select All
              </Typography>
            }
            control={
              <Checkbox
                checked={organizations?.every((org) => selectedOrganizations?.includes(org?.id))}
                onChange={(_, checked) => {
                  if (checked) {
                    setSelectedOrganizations(organizations?.map((org) => org?.id));
                  } else {
                    setSelectedOrganizations([]);
                  }
                }}
              />
            }
          />
          {organizations?.map((org) => {
            return (
              <FormControlLabel
                key={org?.id}
                label={org?.name}
                control={
                  <Checkbox
                    checked={selectedOrganizations?.includes(org?.id)}
                    onChange={(_, checked) => {
                      let newSelectedOrgs = [...selectedOrganizations];

                      if (checked) {
                        newSelectedOrgs.push(org?.id);
                      } else {
                        newSelectedOrgs = newSelectedOrgs?.filter((o) => o !== org?.id);
                      }

                      setSelectedOrganizations(newSelectedOrgs);
                    }}
                  />
                }
              ></FormControlLabel>
            );
          })}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" color={'error'} onClick={handleDeleteUser}>
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
